/* eslint-disable @typescript-eslint/no-magic-numbers */
// via https://eepower.com/resistor-guide/resistor-standards-and-codes/resistor-values/#
export const e6StandardValuesInOhms = [10, 15, 22, 33, 47, 68];
// via https://eepower.com/resistor-guide/resistor-standards-and-codes/resistor-values/#
export const e12StandardValuesInOhms = [10, 12, 15, 18, 22, 27, 33, 39, 47, 56, 68, 82];
// via https://eepower.com/resistor-guide/resistor-standards-and-codes/resistor-values/#
export const e24StandardValuesInOhms = [
    10, 11, 12, 13, 15, 16, 18, 20, 22, 24, 27, 30, 33, 36, 39, 43, 47, 51, 56, 62, 68, 75, 82, 91,
];
// via https://eepower.com/resistor-guide/resistor-standards-and-codes/resistor-values/#
export const e48StandardValuesInOhms = [
    10.0, 10.5, 11.0, 11.5, 12.1, 12.7, 13.3, 14.0, 14.7, 15.4, 16.2, 16.9, 17.8, 18.7, 19.6, 20.5, 21.5, 22.6, 23.7,
    24.9, 26.1, 27.4, 28.7, 30.1, 31.6, 33.2, 34.8, 36.5, 38.3, 40.2, 42.2, 44.2, 46.4, 48.7, 51.1, 53.6, 56.2, 59.0,
    61.9, 64.9, 68.1, 71.5, 75.0, 78.7, 82.5, 86.6, 90.9, 95.3,
];
// via https://eepower.com/resistor-guide/resistor-standards-and-codes/resistor-values/#
export const e96StandardValuesInOhms = [
    10.0, 10.2, 10.5, 10.7, 11.0, 11.3, 11.5, 11.8, 12.1, 12.4, 12.7, 13.0, 13.3, 13.7, 14.0, 14.3, 14.7, 15.0, 15.4,
    15.8, 16.2, 16.5, 16.9, 17.4, 17.8, 18.2, 18.7, 19.1, 19.6, 20.0, 20.5, 21.0, 21.5, 22.1, 22.6, 23.2, 23.7, 24.3,
    24.9, 25.5, 26.1, 26.7, 27.4, 28.0, 28.7, 29.4, 30.1, 30.9, 31.6, 32.4, 33.2, 34.0, 34.8, 35.7, 36.5, 37.4, 38.3,
    39.2, 40.2, 41.2, 42.2, 43.2, 44.2, 45.3, 46.4, 47.5, 48.7, 49.9, 51.1, 52.3, 53.6, 54.9, 56.2, 57.6, 59.0, 60.4,
    61.9, 63.4, 64.9, 66.5, 68.1, 69.8, 71.5, 73.2, 75.0, 76.8, 78.7, 80.6, 82.5, 84.5, 86.6, 88.7, 90.9, 93.1, 95.3,
    97.6,
];
// via https://eepower.com/resistor-guide/resistor-standards-and-codes/resistor-values/#
export const e192StandardValuesInOhms = [
    10.0, 10.1, 10.2, 10.4, 10.5, 10.6, 10.7, 10.9, 11.0, 11.1, 11.3, 11.4, 11.5, 11.7, 11.8, 12.0, 12.1, 12.3, 12.4,
    12.6, 12.7, 12.9, 13.0, 13.2, 13.3, 13.5, 13.7, 13.8, 14.0, 14.2, 14.3, 14.5, 14.7, 14.9, 15.0, 15.2, 15.4, 15.6,
    15.8, 16.0, 16.2, 16.4, 16.5, 16.7, 16.9, 17.2, 17.4, 17.6, 17.8, 18.0, 18.2, 18.4, 18.7, 18.9, 19.1, 19.3, 19.6,
    19.8, 20.0, 20.3, 20.5, 20.8, 21.0, 21.3, 21.5, 21.8, 22.1, 22.3, 22.6, 22.9, 23.2, 23.4, 23.7, 24.0, 24.3, 24.6,
    24.9, 25.2, 25.5, 25.8, 26.1, 26.4, 26.7, 27.1, 27.4, 27.7, 28.0, 28.4, 28.7, 29.1, 29.4, 29.8, 30.1, 30.5, 30.9,
    31.2, 31.6, 32.0, 32.4, 32.8, 33.2, 33.6, 34.0, 34.4, 34.8, 35.2, 35.7, 36.1, 36.5, 37.0, 37.4, 37.9, 38.3, 38.8,
    39.2, 39.7, 40.2, 40.7, 41.2, 41.7, 42.2, 42.7, 43.2, 43.7, 44.2, 44.8, 45.3, 45.9, 46.4, 47.0, 47.5, 48.1, 48.7,
    49.3, 49.9, 50.5, 51.1, 51.7, 52.3, 53.0, 53.6, 54.2, 54.9, 55.6, 56.2, 56.9, 57.6, 58.3, 59.0, 59.7, 60.4, 61.2,
    61.9, 62.6, 63.4, 64.2, 64.9, 65.7, 66.5, 67.3, 68.1, 69.0, 69.8, 70.6, 71.5, 72.3, 73.2, 74.1, 75.0, 75.9, 76.8,
    77.7, 78.7, 79.6, 80.6, 81.6, 82.5, 83.5, 84.5, 85.6, 86.6, 87.6, 88.7, 89.8, 90.9, 92.0, 93.1, 94.2, 95.3, 96.5,
    97.6, 98.8,
];
// via https://www.rfcafe.com/references/electrical/capacitor-values.htm
export const standardCapacitance = [
    100, 101, 102, 104, 105, 106, 107, 109, 110, 111, 113, 114, 115, 117, 118, 120, 121, 123, 124, 126, 127, 129, 130,
    132, 133, 135, 137, 138, 140, 142, 143, 145, 147, 149, 150, 152, 154, 156, 158, 160, 162, 164, 165, 167, 169, 172,
    174, 176, 178, 180, 182, 184, 187, 189, 191, 193, 196, 198, 200, 203, 205, 208, 210, 213, 215, 218, 221, 223, 226,
    229, 232, 234, 237, 240, 243, 246, 249, 252, 255, 258, 261, 264, 267, 271, 274, 277, 280, 284, 287, 291, 294, 298,
    301, 305, 309, 312, 316, 320, 324, 328, 332, 336, 340, 344, 348, 352, 357, 361, 365, 370, 374, 379, 383, 388, 392,
    397, 402, 407, 412, 417, 422, 427, 432, 437, 442, 448, 453, 459, 464, 470, 475, 481, 487, 493, 499, 505, 511, 517,
    523, 530, 536, 542, 549, 556, 562, 569, 576, 583, 590, 597, 604, 612, 619, 626, 634, 642, 649, 657, 665, 673, 681,
    690, 698, 706, 715, 723, 732, 741, 750, 759, 768, 777, 787, 796, 806, 816, 825, 835, 845, 856, 866, 876, 887, 898,
    909, 920, 931, 942, 953, 965, 976, 988,
];
export function nearestValueFromArray(input, value) {
    return input.reduce((a, b) => {
        return Math.abs(b - value) < Math.abs(a - value) ? b : a;
    });
}
// via https://jansson.us/resistors.html
export function calculateResistanceFromEStandardValuesArray(input, resistance /* Note that this is not necessarily a native number, but more likely a Decimal2 instance from mathjs */) {
    if (resistance <= 0) {
        return 0.0;
    }
    const scaledInputs = input.map((it) => it * 0.1);
    const findFirstLower = (res) => {
        // Find first value < res in series
        res = Math.max(1, res); // Not less than one Ohm
        let index = Math.log(res) / Math.LN10; // Base 10 logarithm
        let multiplier = Math.floor(index); // Round down
        index = Math.floor((index - multiplier) * scaledInputs.length); // Index into series
        multiplier = Math.pow(10, multiplier);
        return { index, multiplier };
    };
    // Find next higher value in series
    const findNextHigher = (index, multiplier) => index < scaledInputs.length - 1
        ? {
            index: index + 1,
            multiplier,
        }
        : {
            index: 0,
            multiplier: multiplier * 10,
        };
    const findBestMatch = (resistanceValue) => {
        const resLow = findFirstLower(resistanceValue);
        const resHigh = findNextHigher(resLow.index, resLow.multiplier);
        const errLow = (scaledInputs[resLow.index] * resLow.multiplier - resistanceValue) / resistanceValue;
        const errHigh = (scaledInputs[resHigh.index] * resHigh.multiplier - resistanceValue) / resistanceValue;
        // Which produces less error, the low value or high value?
        return Math.abs(errHigh) < Math.abs(errLow) ? resHigh : resLow;
    };
    const resistanceClosest = findBestMatch(resistance);
    const resistanceTwoDp = Math.round(100 * input[resistanceClosest.index] * resistanceClosest.multiplier) / 100;
    return resistanceTwoDp / 10.0;
}
//# sourceMappingURL=calculateResistanceFromEStandardValuesArray.js.map